import React from 'react';
import s from './BaseComp.scss';
// models

export const FocusImageLoading = () => {
    return (
        <div className={s.focusImageLoading}>
            <div className={s.coverBox} />
            <div className={s.label} />
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/components/BaseComp/FocusImage.loading.tsx